import { useState, useEffect } from "react";

interface TypeTextProps {
  /** 要打字的文字，用 \n 換行。 */
  text: string;
  /** 每字間隔（ms）。 */
  speed?: number;
  /** 開始前延遲（ms）。 */
  startDelay?: number;
  /** 是否顯示閃爍游標。 */
  cursor?: boolean;
}

/**
 * 打字機（Text Type）效果：文字逐字浮現 + 末端閃爍游標。
 * 尊重 prefers-reduced-motion（直接全顯示、不動畫）。游標顏色沿用 currentColor。
 */
const TypeText = ({ text, speed = 95, startDelay = 260, cursor = true }: TypeTextProps) => {
  const reduce =
    typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const [count, setCount] = useState(reduce ? text.length : 0);

  useEffect(() => {
    if (reduce) {
      setCount(text.length);
      return;
    }
    setCount(0);
    let i = 0;
    let next = 0;
    const start = window.setTimeout(function tick() {
      i += 1;
      setCount(i);
      if (i < text.length) next = window.setTimeout(tick, speed);
    }, startDelay);
    return () => {
      window.clearTimeout(start);
      window.clearTimeout(next);
    };
  }, [text, speed, startDelay, reduce]);

  const lines = text.slice(0, count).split("\n");

  return (
    <span>
      <style>{`@keyframes tt-blink{0%,45%{opacity:1}55%,100%{opacity:0}}`}</style>
      {lines.map((ln, i) => (
        <span key={i}>
          {ln}
          {i < lines.length - 1 && <br />}
        </span>
      ))}
      {cursor && (
        <span
          aria-hidden
          style={{
            display: "inline-block",
            width: "0.5em",
            marginLeft: "0.02em",
            fontWeight: 400,
            transform: "translateY(-0.02em)",
            animation: "tt-blink 1.05s steps(1) infinite",
          }}
        >
          |
        </span>
      )}
    </span>
  );
};

export default TypeText;
